import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from './store'
import axios from 'axios'
import { App } from './config.js'

Vue.use(VueRouter)

const router = new VueRouter({
  routes
})



router.beforeEach((to, from, next) => {
  store.dispatch('auth/check').then(async () => {
    if (to.matched.some(m => m.meta.auth) && !store.state.auth.authenticated) {

      next({
        name: 'login'
      })
    } else if (to.matched.some(m => m.meta.admin) && store.state.auth.is_admin == false) {
      next({
        name: 'accounts'
      })
    } else {
      //sets Client and website title
      if (to.name != 'login' && to.name != 'resetpassword') {
        var client = await store.state.auth.client;
        if (client == null) {
          var setClient = await store.dispatch("auth/setClient").then(() => {
            client = store.state.auth.client;
          });
        }
        document.title = client == null ? App.name : App.name + " – " + client;
      }
      

      //if no dashboards and attempting to go to dashboards 
      var hasDashboards = await store.state.auth.has_dashboards
      if (hasDashboards == false && (to.name == 'dashboards' || to.name == 'dashboard view'|| to.name == 'my dashboards')){
     
        //return back to previous page
        if (from.name !='login'|| from.name != 'resetpassword'){
          next({
            name:from.name
          })
        }
        //go to home page if from login
        else{
          next({path:"/"})
        }
        
      }else{
        //save last page visited
        if ((to.name != from.name) && (to.name != 'login') && (from.name != 'login') && (to.name != 'resetpassword') && (from.name != 'resetpassword')) {
          axios
            .post(
              "/api/User/UpdateLastPage/", { LastPage: to.path }
            )
            .catch(err => {
              console.log(err)
            });
        }
        next()
      }
    }
  })
})

export default router
